'use es6';

import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import bestContrastColor from 'feedback-utils/bestContrastColor';
import * as SurveyTypes from 'feedback-schema/constants/surveyTypes';
import { renderStyledTagText } from 'feedback-shared-ui/tokens';
import CsatRating from 'feedback-shared-ui/ratings/Csat';
import NpsRating from 'feedback-shared-ui/ratings/Nps';
import * as DeviceTypes from 'feedback-schema/constants/devices';
import * as PopupStyles from 'feedback-schema/constants/surveyProperties/popupStyles';
import { NavMarker } from 'react-rhumb';
import PreviewRibbon from '../PreviewRibbon';
import { Selectors } from '../../Constants';
import * as Modes from '../../constants/modes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const QuestionInputs = ({
  deviceType,
  onRatingSelect,
  ratingLabels,
  surveyType,
  useTrellisSmileys
}) => {
  switch (surveyType) {
    case SurveyTypes.NPS:
      {
        const deviceTypeKey = deviceType === DeviceTypes.MOBILE ? 'mobile' : 'desktop';
        const labels = ratingLabels[deviceTypeKey];
        return /*#__PURE__*/_jsx(View, {
          marginBlock: "500",
          children: /*#__PURE__*/_jsx(NpsRating, {
            device: deviceType,
            lowRangeLabel: labels.low,
            highRangeLabel: labels.high,
            onChange: onRatingSelect,
            isWebSurvey: true
          })
        });
      }
    case SurveyTypes.CSAT:
      return /*#__PURE__*/_jsx(CsatRating, {
        className: "csat-rating",
        onChange: onRatingSelect,
        size: 65,
        spacing: 8,
        useTrellisSmileys: useTrellisSmileys
      });
    default:
      return null;
  }
};
const Question = ({
  config: {
    embedStyle,
    question,
    ratingLabels,
    surveyType,
    themeColor
  },
  deviceType,
  mode,
  onRatingSelect,
  contactProperties,
  useTrellisSmileys
}) => /*#__PURE__*/_jsxs("div", {
  className: "question-page",
  "data-selenium-test": Selectors.HOMEPAGE,
  "aria-live": "polite",
  children: [/*#__PURE__*/_jsx("div", {
    className: "heading",
    "data-selenium-test": Selectors.QUESTION,
    style: {
      backgroundColor: themeColor,
      color: bestContrastColor(themeColor)
    },
    children: /*#__PURE__*/_jsx("span", {
      "data-selenium-test": "token-preview-tag-SURVEY_QUESTION",
      role: "heading",
      "aria-level": "2",
      children: question && contactProperties && renderStyledTagText(question, contactProperties) || /*#__PURE__*/_jsx("div", {
        children: "\xA0"
      })
    })
  }), /*#__PURE__*/_jsxs(View, {
    paddingBlockStart: mode === Modes.LIVE_PREVIEW && !((surveyType === SurveyTypes.NPS ? deviceType === DeviceTypes.DESKTOP : deviceType !== DeviceTypes.MOBILE) && embedStyle === PopupStyles.POPUP_TOP) ? '500' : '0',
    children: [mode === Modes.LIVE_PREVIEW && /*#__PURE__*/_jsx(PreviewRibbon, {}), /*#__PURE__*/_jsx(NavMarker, {
      name: "question",
      children: /*#__PURE__*/_jsx(Flex, {
        justifyContent: "center",
        "data-selenium-test": "rating-buttons-wrapper",
        children: /*#__PURE__*/_jsx(QuestionInputs, {
          deviceType: deviceType,
          onRatingSelect: onRatingSelect,
          ratingLabels: ratingLabels,
          surveyType: surveyType,
          useTrellisSmileys: useTrellisSmileys
        })
      })
    })]
  })]
});
export default Question;